import React, { useContext, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Toolbar,
  IconButton,
  Typography,
  Menu,
  MenuItem,
  Badge,
  Button,
  Avatar
} from "@material-ui/core";
// import AccountCircle from "@material-ui/icons/AccountCircle";
import LangSelect from "./LangSelect";
import { AuthContext } from "../../auths/Auth";
import useStyles from "../../styles/appBarRightStyle";
import { useTranslation } from "../../langs/useTranslation";
import { SubmitBtnContext } from "../../App";
import * as localforage from "localforage";
import SearchBar from "./SearchBar";
import Help from "@material-ui/icons/Help";
import { qaUrl } from "../../config/optionsOnAppBar";
import CompanySelector from "../CompanyTree/Selector";
import { useGlobalDispatch, getCurrentCompanyId } from "../../GlobalProvider";
import NotificationIconBtn from "./AppBarNotificationIconBtn";
import { ArrowDropDown } from "@material-ui/icons";
import { setLastGroupState } from "@/containers/GroupsDevices/Provider";

export const ModalContext = React.createContext();
const AppbarRightSection = () => {
  const classes = useStyles();
  const { t, langConf } = useTranslation("common");
  const [anchorEl, setAnchorEl] = useState(null); // User menu pop out position
  const [modalOpen, setModalOpen] = useState(false);
  const [username, setUsername] = useState("");
  const [avatar, setUserAvatar] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState();
  const { dispatch } = useContext(SubmitBtnContext);
  const { logout } = useContext(AuthContext);
  const globalDispatch = useGlobalDispatch();

  const isMenuOpen = Boolean(anchorEl);
  const history = useHistory();

  const handleCompanySelect = (companyId, info) => {
    setSelectedCompanyId(companyId[0]);
    globalDispatch.setCurrentCompany(companyId[0], info.node.name);
    if (!history.location.pathname.startsWith("/groups/groups-devices")) {
      setLastGroupState(null);
    }
  };

  const getUserInfo = async () => {
    const user = await localforage.getItem("user");
    if (user) {
      setUsername(user.name);
      setUserAvatar(user.avatar_link);
    }
  };

  const handleProfileMenuOpen = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    logout(true, true);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    dispatch({ type: "stopLoading" });
  };

  const getAndSetCurrentCompanyId = async () => {
    const companyId = await getCurrentCompanyId();
    if (companyId) {
      setSelectedCompanyId(companyId);
    }
  };

  const renderUserMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      // keepMounted
      className={`${classes.menuList} ${classes.initialHeightPopOver}`}
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleLogout}>{t("appbar.logoutBtn")}</MenuItem>
    </Menu>
  );

  useEffect(() => {
    getUserInfo();
    getAndSetCurrentCompanyId();
  }, []);

  return (
    <ModalContext.Provider value={{ setAnchorEl, modalOpen, handleModalClose }}>
      <div className={classes.grow}>
        <Toolbar>
          <div className={classes.rightSection}>
            <div style={{ marginRight: 10 }}>
              <CompanySelector
                companyId={selectedCompanyId}
                onSelect={handleCompanySelect}
              />
            </div>
            <SearchBar />
            <LangSelect />
            <a
              href={langConf.supportCenter?.text? langConf.supportCenter.text: qaUrl}
              target="_blank"
              rel="noreferrer"
              className={classes.qaLink}
            >
              <IconButton aria-label="Q&A" color="inherit">
                <Badge color="error" overlap="rectangular">
                  <Help />
                </Badge>
              </IconButton>
            </a>
            {/* <IconButton
                aria-label="Notifications"
                color="inherit"
                onClick={handleNotificationMenuOpen}
              >
                <Badge variant="dot" color="error" overlap="rectangular">
                  <NotificationsIcon />
                </Badge>
              </IconButton> */}
            <NotificationIconBtn />
            <Button
              edge="end"
              aria-label="User"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              className={classes.ueserBtn}
            >
              {avatar ? (
                <Avatar
                  src={avatar}
                  alt={username}
                  className={classes.avatar}
                />
              ) : (
                <Avatar className={classes.avatar}>
                  {username.charAt(0).toUpperCase()}
                </Avatar>
              )}
              <Typography variant="caption" className={classes.usernameText}>
                {username}
              </Typography>
              <ArrowDropDown />
            </Button>
          </div>
        </Toolbar>
        {renderUserMenu}
      </div>
    </ModalContext.Provider>
  );
};

export default AppbarRightSection;
